import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

const KEY = "bera:share_intent_property";
const DONE = "bera:share_intent_done";

/** Remembers a shared property a visitor opened before signing in. */
export function rememberShareIntent(propertyId: string) {
  try {
    localStorage.setItem(KEY, propertyId);
  } catch {}
}

/**
 * After sign-in, turns a remembered shared-link visit into a
 * "continue your booking" notification (menu + branded email).
 */
export function useShareIntent() {
  const { user } = useAuth();
  const location = useLocation();

  // Capture the intent while the visitor is still signed out.
  useEffect(() => {
    if (user) return;
    const match = location.pathname.match(/^\/imovel\/([^/?]+)/);
    if (match) rememberShareIntent(match[1]);
  }, [user, location.pathname]);

  // Fire the notification once the user is authenticated.
  useEffect(() => {
    if (!user?.id) return;
    let pending: string | null = null;
    try {
      pending = localStorage.getItem(KEY);
      if (!pending || localStorage.getItem(DONE) === `${user.id}:${pending}`) return;
    } catch {
      return;
    }
    const propertyId = pending;
    void supabase.functions
      .invoke("share-intent-notify", { body: { property_id: propertyId } })
      .then(() => {
        try {
          localStorage.setItem(DONE, `${user.id}:${propertyId}`);
          localStorage.removeItem(KEY);
        } catch {}
      })
      .catch(() => {});
  }, [user?.id]);
}
